import React from 'react';
import { EditorialNum } from './EditorialNum';

const STATS = [
  { n: '980', label: 'figurinhas no álbum' },
  { n: '48', label: 'seleções' },
  { n: '19', label: 'por seleção' },
  { n: '14', label: 'Coca-Cola colecionáveis' },
];

export function NumbersBanner() {
  return (
    <section className="bg-green-900 text-white py-10 md:py-14">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {STATS.map((s) => (
            <div key={s.label} className="flex flex-col items-start gap-1">
              <EditorialNum n={s.n} size="lg" className="text-gold-500" />
              <span className="font-body text-small text-white/70">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
